import type { SanityPageBuilderHighlightsHighlight, SanityPageBuilderHighlightsSection, SanityPageBuilderSection } from "@ouster/shared";
import { HighlightsBlockView } from "~/features/blocks/inventory/highlights";
import { HighlightsHighlightView, type HighlightsHighlightViewProps } from "~/features/blocks/inventory/highlights/highlights-highlight";
import { toCraftLinkArray } from "~/features/sanity/link";
import { SanityRichText } from "~/features/sanity/rich-text";
import { SanityMediaFigure, hasRenderableSanityMedia } from "./media-figure";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderHighlightsSection;
  };
};
type HighlightsViewItem = Omit<HighlightsHighlightViewProps, "count" | "horizontal"> & Pick<SanityPageBuilderHighlightsHighlight, "_key">;
export function SanityHighlightsSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const text = sectionContent.text?.length ? <SanityRichText value={sectionContent.text} /> : undefined;
  const footerLogo = sectionContent.footerLogo;
  const highlights = sectionContent.highlights?.map<HighlightsViewItem>(highlight => ({
    _key: highlight._key,
    link: toCraftLinkArray(highlight.link),
    text: highlight.text?.length ? <SanityRichText value={highlight.text} /> : undefined,
    title: highlight.title
  })) ?? [];
  return <HighlightsBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} footerLogo={hasRenderableSanityMedia(footerLogo) ? <SanityMediaFigure media={footerLogo} fit="cover" ratio="4/3" /> : undefined} footerTitle={sectionContent.footerTitle} getItemKey={(item, index) => item._key || index} hasCounters={sectionContent.hasCounters} hasFooter={sectionContent.hasFooter} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} highlights={highlights} link={toCraftLinkArray(sectionContent.link)} mode={sectionSettings?.mode || "light"} renderHighlight={(item, _index, count, horizontal) => <HighlightsHighlightView count={count} horizontal={horizontal} link={item.link} text={item.text} title={item.title} />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} text={text} theme={sectionSettings?.theme || "white"} />;
}